import React, { useState } from 'react'
import SelectTalentWithAddButton from './sections/talent/SelectTalentWithAddButton';
import UserTalents from '../components/UserTalents';
import { getDefaultValue } from '../utils';
import { useStateValue } from '../StateProvider';


export default function TalentPanel() {

    const [userTalentsReloadKey, setUserTalentsReloadKey] = useState(0);

    const [{ translations }] = useStateValue();
    const translate = (str) => {
        if (!translations) return str;
        var translate = translations.find(x=>x.key == str );
    
        if (translate) return getDefaultValue(translate);
        else return "#" + str;
      };


    return (
        <div className="mt-2">
            <div className="mb-4">
                <SelectTalentWithAddButton
                    placeholder={translate('Select a Talent')}
                    onTalentAdded={() => setUserTalentsReloadKey((k) => k + 1)}
                />
            </div>
            <UserTalents reloadKey={userTalentsReloadKey} />


        </div>

    )

}
